import { AuthBackLink } from '@/components/auth/AuthBackLink';
import { ForgotPasswordForm } from '@/components/auth/ForgotPasswordForm';
import { AuthMobileLayout, AuthDesktopLayout } from '@/components/auth/AuthLayouts';

export default function ForgotPasswordPage() {
  return (
    <>
      <div className="block lg:hidden" data-testid="auth-mobile-section">
        <AuthMobileLayout backLink={<AuthBackLink />}>
          <ForgotPasswordForm />
        </AuthMobileLayout>
      </div>
      <div className="hidden lg:block" data-testid="auth-desktop-section">
        <AuthDesktopLayout>
          <div className="mb-4">
            <AuthBackLink />
          </div>
          <ForgotPasswordForm />
        </AuthDesktopLayout>
      </div>
    </>
  );
}
